"use strict";
require('./ObjectAssignPolyfill');
function typeName(name) {
    return function (actionClass) {
        // Although we could determine the type name using actionClass.prototype.constructor.name,
        // it's dangerous to do that because minifiers may interfere with it, and then serialized state
        // might not have the expected meaning after a recompile. So we explicitly ask for a name string.
        actionClass.prototype.type = name;
    };
}
exports.typeName = typeName;
function isActionType(action, actionClass) {
    return action.type == actionClass.prototype.type;
}
exports.isActionType = isActionType;
// Middleware for transforming Typed Actions into plain actions
exports.typedToPlain = function (store) { return function (next) { return function (action) {
    next(Object.assign({}, action));
}; }; };
var Action = (function () {
    function Action() {
        // Make it an own-property (not a prototype property) so that it's included when JSON-serializing
        this.type = this.type;
    }
    return Action;
}());
exports.Action = Action;
